module.exports = __webpack_public_path__ + "img/nt117-04-81-1.prt.0f842c71.jpg";